import { Injectable } from "@angular/core";
import { BusinessUnitDetails, MetaDataResponse, SalesOfficeDetails, SegmentDetails, SubSegmentDetails, ZoneOfficeIds } from "../models/dtos";

@Injectable({
    providedIn: 'root'
})
export class CommonMetaDataService {
    private _metaData: MetaDataResponse;


    setMetaData(metaData: MetaDataResponse): void {
        this._metaData = metaData;
    }

    getMetaData(): MetaDataResponse {
        return this._metaData;
    }

    updateAllZoneOfficeIds(allZoneOfficeIds: ZoneOfficeIds): void {
        if (!this._metaData) {
            return;
        }

        this._metaData = {
            ...this._metaData,
            allZoneOfficeIds
        };
    }

    /**
     * Resets cached metadata.
     * Called when the user closes an estimate/project.
     */
    resetEstimateState(): void {
        this._metaData = null;
    }

    getSalesOfficeDetails(salesOfficeId: number): SalesOfficeDetails | undefined {
        if (!this._metaData?.salesOfficesDetails) {
            return undefined;
        }
        return this._metaData.salesOfficesDetails.find(so => so.salesOfficeId === salesOfficeId);
    }

    getSegmentDetails(segmentId: number): SegmentDetails | undefined {
        if (!this._metaData?.segments) {
            return undefined;
        }
        return this._metaData.segments.find(s => s.zweigId === segmentId);
    }

    getSubSegmentDetails(subSegmentId: number): SubSegmentDetails | undefined {
        if (!this._metaData?.subSegments) {
            return undefined;
        }
        return this._metaData.subSegments.find(ss => ss.subSegmentId === subSegmentId);
    }

    getBusinessUnitDetails(businessUnitId: number): BusinessUnitDetails | undefined {
        if (!this._metaData?.businessUnits) {
            return undefined;
        }
        return this._metaData.businessUnits.find(bu => bu.businessUnitId === businessUnitId);
    }

    getUserProfile() {
        return this._metaData?.userProfile;
    }

    getGeneralConfigurations() {
        return this._metaData?.generalConfigurations;
    }
}
